
import Vue from "vue";
import HitList from "./components/HitList.vue";
// import ShowMore from './components/ShowMore.vue';
import Pagination from "./components/Pagination.vue";
import HitCount from "./components/HitCount.vue";
import SearchBox from "./components/SearchBox.vue";
import { ITranslations } from "./store/state";

// Interfaces for component typechecking!
interface AppData {}

interface AppMethods {}

interface AppComputed {
  showMore: boolean;
  searchedQuery: string;
  translations: ITranslations;
  resultsCount: number;
  resultsPerPage: number;
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
  name: "app",
  computed: {
    showMore() {
      return this.$store.getters.showMore;
    },
    searchedQuery() {
      return this.$store.getters.searchedQuery;
    },
    translations() {
      return this.$store.getters.translations;
    },
    resultsCount() {
      return this.$store.getters.totalHits;
    },
    resultsPerPage() {
      return this.$store.getters.hitsPerPage;
    },
  },
  components: {
    HitList,
    // ShowMore,
    Pagination,
    HitCount,
    SearchBox,
  },
});
